(function () {

    'use strict';

    angular.module('app').controller('AccountingSurchargesController', AccountingSurchargesController);

    AccountingSurchargesController.$inject = ['AccountingSurchargesTableService'];

    function AccountingSurchargesController(AccountingSurchargesTableService) {

        const vm = this;
        vm.surchargesTable = new AccountingSurchargesTableService().tableData;

    }
})();


// WEBPACK FOOTER //
// ./js/controllers/accounting/AccountingSurchargesController.js